import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import userImage from '../../../../../images/user.png';
import clsx from 'clsx';

interface Props {
  user?: any;
  className: string;
  onClick: () => void;
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  picture: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: 38,
    height: 38,
    marginRight: '.5rem',
  },
  title: {
    fontSize: 13,
  },
  subTitle: {
    fontSize: 12,
    color: '#98a6ad',
    fontWeight: 'normal',
  },
});

const ProfileCard: React.FC<Props> = ({ className, user, onClick }) => {
  const [imageError, setImageError] = useState(false);
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} onClick={onClick}>
      <img
        className={classes.picture}
        onError={() => setImageError(true)}
        src={!imageError ? user?.profileImage || userImage : userImage}
        alt='user'
      />
    </div>
  );
};

export default ProfileCard;
